import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { LocalStorageKeys } from "src/utils/localStorageKeys";

export default function useChangeTitle(
  title: string,
  title2?: string,
  booleanDependency?: boolean
) {
  const [originalTitle, setOriginalTitle] = useState<string | null>(null);
  const location = useLocation();
  useEffect(() => {
    const headerTitle = document.getElementById("header-title");
    if (!headerTitle) {
      console.warn("Header title element not found");
      return;
    }

    setOriginalTitle(headerTitle.textContent);
    if (booleanDependency !== undefined && booleanDependency) {
      headerTitle.innerHTML = title2 ? title2 + "<br>" + title : title;
      return;
    } else if (booleanDependency === undefined) {
      headerTitle.innerHTML = title2 ? title2 + "<br>" + title : title;
    } else {
      headerTitle.innerHTML = originalTitle ?? "";
    }
    return () => {
      if (headerTitle && originalTitle) {
        headerTitle.textContent = originalTitle;
      }
    };
  }, [
    title,
    title2,
    location.pathname,
    localStorage.getItem(LocalStorageKeys.groupId),
    booleanDependency,
  ]);
}
